import cx from 'classnames'
import { PressEvent } from '@react-types/shared/src/events'

import { Button } from 'components/Button'
import { ButtonProps } from 'components/Button/Types'
import { Tooltip } from 'components/Tooltip/Tooltip'

import Styles from './Action.module.scss'
import { Shimmerer } from 'blaze-ui/Shimmerer'
import { Icon } from 'almanac-ui/icons/Types'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { ConditionalWrapper } from 'common/ConditionalWrapper/ConditionalWrapper'

export interface ActionProps extends Omit<ButtonProps, 'onClick'> {
  label: string
  tooltip?: string
  icon?: Icon
  iconColor?: string
  upgradeBadge?: React.ReactNode
}

export const Action = ({
  label,
  tooltip,
  icon: Icon,
  iconColor,
  isDisabled: propsIsDisabled,
  upgradeBadge,
  onPress,
  className,
  ...props
}: ActionProps) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const isDisabled = propsIsDisabled

  const handlePress = (e: PressEvent) => {
    if (isDisabled) return

    onPress?.(e)
  }

  return (
    <Tooltip label={tooltip} placement="top" className={Styles.actionTooltip} hide={!tooltip}>
      {/* NOTICE: I hate this extra div too but the tooltip won't show for disable buttons otherwise
                  and we care to say why they are disabled */}
      <div className={Styles.actionWrapper}>
        <ConditionalWrapper
          condition={!isSystemRedesignEnabled}
          wrapper={(children: React.ReactNode) => <Shimmerer variant="secondary">{children}</Shimmerer>}
        >
          <Button
            className={cx(Styles.action, className, {
              [Styles.disabled]: isDisabled,
            })}
            aria-label={label}
            variant="tertiary"
            onPress={handlePress}
            isDisabled={isDisabled}
            size={!!Icon ? 'xl' : 'lg'}
            {...props}
            frontIcon={() => {
              if (!Icon) return null
              return (
                <div className={Styles.icon} style={{ backgroundColor: iconColor }}>
                  <Icon size={isSystemRedesignEnabled ? 18 : undefined} />
                </div>
              )
            }}
          >
            {label}
            {upgradeBadge && <div className={Styles.upgradeBadgeContainer}>{upgradeBadge}</div>}
          </Button>
        </ConditionalWrapper>
      </div>
    </Tooltip>
  )
}
